
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOperationalEntityParentV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateParentInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"updateOperationalEntityParentV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parentInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sources"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"boidAssignments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessOperationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"businessOperationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commonOrgId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dbaName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"legalName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telecomNumbers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddressLine1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"streetAddressLine2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"oems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameplateDescription"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dbaName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"statuses"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"statuses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterpriseEntitlementsV2"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isComplex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenantId"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":966}};
    doc.loc.source = {"body":"mutation UpdateOperationalEntityParentV2($parentInput: UpdateParentInput) {\n  result: updateOperationalEntityParentV2(parentInput: $parentInput) {\n    entity {\n      id\n      sources {\n        sourceId\n        sourceType\n      }\n      boidAssignments {\n        businessOperationType\n        businessOperationId\n        commonOrgId\n      }\n      organizationInformation {\n        dbaName\n        legalName\n        status\n        telecomNumbers\n        address {\n          streetAddressLine1\n          streetAddressLine2\n          city\n          state\n          zip\n          country\n        }\n      }\n      oems {\n        abbreviation\n        id\n        locationId\n        nameplateDescription\n      }\n      parent {\n        id\n        organizationInformation {\n          dbaName\n        }\n        statuses\n      }\n      statuses\n      enterpriseEntitlementsV2 {\n        featureName\n        featureId\n        status\n      }\n      isComplex\n      tenantId\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UpdateOperationalEntityParentV2"] = oneQuery(doc, "UpdateOperationalEntityParentV2");
        
